const React = require('react');
const { MCO, MLA, MLB, MLC, MLM, MLU, MPE } = require('./Images/Countries');

const COUNTRIES_THAT_NOT_ACCEPT_INTEGER = ['CL'];

const getCountryAcronymByPublicKey = (id) => {
  const countries = [
    { id: 'TEST-de563cac-2acb-4ec6-b506-9fb302a2848d', country: 'BR', originalLanguage: 'pt' },
    { id: 'TEST-bfe30303-c7de-4da3-b765-c4be61b4f88b', country: 'AR', originalLanguage: 'es' },
    { id: 'TEST-852eef7f-952a-43ca-887f-19780ecf8ed8', country: 'MX', originalLanguage: 'es' },
    { id: 'TEST-7094fa90-db4e-4dc1-82ed-54072977aae5', country: 'UY', originalLanguage: 'es' },
    { id: 'TEST-af696d89-c335-4cc1-982c-af28f38e7894', country: 'CO', originalLanguage: 'es' },
    { id: 'TEST-36ac5e4f-11ca-4152-93fa-1e90d870ad13', country: 'CL', originalLanguage: 'es' },
    { id: 'TEST-513b4541-d1e6-419b-9cf2-23dc290669ad', country: 'PE', originalLanguage: 'es' },
  ];
  return countries.filter((item) => item.id === id)[0];
};

const countryShouldAcceptInteger = (publicKey) => {
  const { country } = getCountryAcronymByPublicKey(publicKey);
  return !COUNTRIES_THAT_NOT_ACCEPT_INTEGER.includes(country);
};

const CountryOfOperationItems = {
  getJsxItems: (i18n) => ([
    { value: 'TEST-bfe30303-c7de-4da3-b765-c4be61b4f88b', primary: i18n.gettext('Argentina'), icon: <MLA />, siteId: 'MLA' },
    { value: 'TEST-de563cac-2acb-4ec6-b506-9fb302a2848d', primary: i18n.gettext('Brasil'), icon: <MLB />, siteId: 'MLB' },
    { value: 'TEST-852eef7f-952a-43ca-887f-19780ecf8ed8', primary: i18n.gettext('México'), icon: <MLM />, siteId: 'MLM' },
    { value: 'TEST-7094fa90-db4e-4dc1-82ed-54072977aae5', primary: i18n.gettext('Uruguay'), icon: <MLU />, siteId: 'MLU' },
    { value: 'TEST-af696d89-c335-4cc1-982c-af28f38e7894', primary: i18n.gettext('Colombia'), icon: <MCO />, siteId: 'MCO' },
    { value: 'TEST-36ac5e4f-11ca-4152-93fa-1e90d870ad13', primary: i18n.gettext('Chile'), icon: <MLC />, siteId: 'MLC' },
    { value: 'TEST-513b4541-d1e6-419b-9cf2-23dc290669ad', primary: i18n.gettext('Perú'), icon: <MPE />, siteId: 'MPE' },
  ]),
  getFormatedLanguageByCountry: (publicKey, language) => {
    const countryObj = getCountryAcronymByPublicKey(publicKey);
    if (countryObj?.originalLanguage !== language) {
      switch (language) {
        case 'pt':
          return 'pt-BR';
        default:
          return language;
      }
    }
    return `${language}-${countryObj?.country}`;
  },
};

module.exports = { CountryOfOperationItems, getCountryAcronymByPublicKey, countryShouldAcceptInteger };
